export class OccToken {
    accessToken: string;
    refreshToken: string;
    apiContextRoot: string;
    expiresIn: number;
    scope: string;
    tokenType: string;

    constructor(token = null) {
        this.accessToken = token.access_token ? token.access_token : '';
        this.refreshToken = token.refresh_token ? token.refresh_token : this.refreshToken;
        this.apiContextRoot = token.apiContextRoot ? token.apiContextRoot : '';
        this.expiresIn = token.expires_in ? token.expires_in : 0;
        this.scope = token.scope ? token.scope : '';
        this.tokenType = token.token_type ? token.token_type : '';

    }
}
